<section class="relative w-full overflow-hidden flex flex-col" style="background-color: var(--bg-banner, #f8e5d3);">

    <!-- CONTENEDOR PRINCIPAL DEL BANNER -->
    <div
        class="relative max-w-7xl mx-auto w-full min-h-[320px] md:min-h-[600px] flex flex-col md:flex-row items-center justify-between px-4 sm:px-6 md:px-12 py-8 gap-8">

        <!-- LADO IZQUIERDO: TEXTOS + BOTÓN EN LA PARTE INFERIOR -->
        <div class="z-10 flex flex-col items-center md:items-start max-w-xl w-full text-center md:text-left">

            <!-- Títulos Principales -->
            <h1 class="text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-extrabold leading-none tracking-tight font-serif select-none w-full"
                style="color: var(--text-banner-pink, var(--bg-main));">
                <div>{{ titleLine1 }}</div>
                <div class="-mt-1 sm:-mt-4">{{ titleLine2 }}</div>
            </h1>

            <!-- Frase entre comillas -->
            <p class="text-xl sm:text-3xl font-serif italic my-3" style="color: var(--bg-main);">
                “{{ subtitleQuote }}”
            </p>

            <!-- Botón Centrado Inferior -->
            <div class="mt-4 w-full flex justify-center md:justify-start">
                <button (click)="onActionButtonClick()"
                    class="bg-white px-7 py-3 rounded-2xl shadow-md hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 font-bold text-xs md:text-sm tracking-wider uppercase cursor-pointer active:scale-95 border border-white/60"
                    style="color: var(--bg-main);">
                    {{ actionButtonText }}
                </button>
            </div>

        </div>

        <!-- LADO DERECHO: CONTENEDOR DE IMAGEN (Ahora visible y adaptativo en Móvil) -->
        <div
            class="relative flex items-center justify-center w-full max-w-[340px] sm:max-w-[380px] md:max-w-[480px] h-[260px] sm:h-[360px] md:h-[450px]">

            <!-- Marco de Imagen -->
            <div class="w-full h-full rounded-3xl overflow-hidden shadow-lg border-4 border-white">
                <img [src]="imageUrl" alt="Banner Principal"
                    class="w-full h-full object-cover object-center transform hover:scale-105 transition-transform duration-700" />
            </div>

            <!-- SELLO CIRCULAR ROTATIVO -->
            <div class="absolute -top-4 -right-4 sm:-top-5 sm:-right-5 z-20 pointer-events-none">
                <div class="relative w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full border-2 border-white/80 shadow-lg flex items-center justify-center animate-spin-slow"
                    style="background-color: var(--bg-main);">
                    <svg class="w-full h-full p-1 fill-white" viewBox="0 0 100 100">
                        <path id="circlePath" d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"
                            fill="none" />
                        <text font-size="9.5" font-weight="bold" letter-spacing="2">
                            <textPath href="#circlePath" startOffset="0%">
                                LINEA DE ARREGLOS PREMIUM •
                            </textPath>
                        </text>
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center text-white">
                        <svg class="w-5 h-5 sm:w-7 sm:h-7 fill-current" viewBox="0 0 24 24">
                            <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                        </svg>
                    </div>
                </div>
            </div>

        </div>

    </div>

    <!-- CINTA INFERIOR DE TEXTO CONTINUO -->
    <div class="w-full overflow-hidden py-4 sm:py-6 text-white text-xs md:text-base md:py-8 font-bold tracking-widest uppercase cursor-pointer select-none border-t border-b border-white/20"
        style="background-color: var(--bg-secondary);">
        <div class="animate-ticker">
            <ng-container *ngFor="let repeat of [1, 2]">
                <div *ngFor="let item of tickerItems" class="flex items-center px-4 sm:px-6 whitespace-nowrap">
                    <a [routerLink]="item.url || null" class="hover:underline flex items-center gap-3 sm:gap-4 text-white">
                        <span>{{ item.text }}</span>
                        <svg class="w-3.5 h-3.5 sm:w-4 sm:h-4 fill-white opacity-80" viewBox="0 0 24 24">
                            <path
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
                        </svg>
                    </a>
                </div>
            </ng-container>
        </div>
    </div>

</section>